import {
  useExecuteKentRebalancePlanMutation,
  useExecuteRebalancePlanMutation,
} from 'hooks/mutations/rebalancer';

import { useIsKentRebalancingMode } from './useIsKentRebalancingMode';

export const useCorrectExecuteRebalancePlanMutation = () => {
  const isKentRebalancingMode = useIsKentRebalancingMode();

  const regularMutation = useExecuteRebalancePlanMutation();

  const kentMutation = useExecuteKentRebalancePlanMutation();

  return isKentRebalancingMode ? kentMutation : regularMutation;
};
